import React, { useState, Dispatch, SetStateAction } from 'react';

import { Button } from '@cloudez/cloudez-design-system';

import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CloudUser } from 'types/cloud';
import { Card, Username, Spam } from './styles';

import UserModal from '../UserModal';

interface IUserCardProps {
  user: CloudUser;
  setUsers: Dispatch<SetStateAction<CloudUser[]>>;
}

const UserCard: React.FC<IUserCardProps> = ({ user, setUsers }) => {
  const [modal, setModal] = useState(false);

  return (
    <Card spam={user.is_spammer}>
      {user.is_spammer && <Spam>spammer</Spam>}
      {modal && (
        <UserModal
          setShow={() => setModal(false)}
          show={modal}
          user={user}
          setUsers={setUsers}
        />
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <FontAwesomeIcon icon={faUserCircle} />
        <Username>{user.username}</Username>
      </div>
      <Button
        size="mn"
        outline
        style={{
          width: '110px',
        }}
        onClick={() => setModal(true)}
      >
        Alterar
      </Button>
    </Card>
  );
};

export default UserCard;
